import { Avatar, AvatarFallback } from "@/v2/components/ui/avatar";
import { Badge } from "@/v2/components/ui/badge";

function initialsFor(email?: string | null): string {
  if (!email) return "?";
  const local = email.split("@")[0] ?? email;
  const parts = local.split(/[._-]+/).filter(Boolean);
  const letters = parts.length >= 2 ? [parts[0][0], parts[1][0]] : [local[0]];
  return letters.join("").toUpperCase();
}

export function SharedByBanner({ sharedByEmail }: { sharedByEmail?: string | null }) {
  return (
    <div
      className="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-card"
      style={{ padding: "10px 16px" }}
    >
      <div className="flex items-center gap-2.5 min-w-0">
        <Avatar size="sm">
          <AvatarFallback className="bg-action-light text-action font-bold">
            {initialsFor(sharedByEmail)}
          </AvatarFallback>
        </Avatar>
        <span className="text-sm text-slate-600 truncate">
          <span className="font-semibold text-slate-900">
            {sharedByEmail ?? "Another user"}
          </span>{" "}
          shared this Spotlight with you. It is now yours to manage
        </span>
      </div>
      <Badge variant="secondary" className="shrink-0 font-bold">
        In Your Library
      </Badge>
    </div>
  );
}
